// export const BASE_URL = "http://192.168.100.100:7000";

export const BASE_URL = "https://thrive-soc.herokuapp.com";

export const QUESTION_TYPES = {
  ANSWER: "free",
  YESNO: "yesNo",
  RATING: "scale"
};



// WEBPACK FOOTER //
// ./src/config/constants.js